<template>
  <v-container class="pa-4" style="height: 100vh">
    <v-row no-gutters>
      <v-col cols="12" class="d-flex">
        <v-btn
          fab
          x-small
          :color="site.color"
          @click="redirectTo()"
          dark
          class="mb-4"
        >
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
        <p
          class="text-dot text-subtitle-1 text--primary mx-0 mb-0 ml-4"
          style="padding-top: 2px"
        >
          {{ dataDetail.name }}
        </p>
      </v-col>
    </v-row>

    <v-row
      no-gutters
      style="margin-left: -16px; margin-right: -16px; height: calc(100% - 32px)"
    >
      <v-col cols="12">
        <div
          v-if="dataDetail.source == 'internal'"
          class="d-flex justify-center align-center"
          style="width: 100%; height: 100%"
          :style="{
            minHeight: dataDetail.canvas_setting.height + 'px',
            background: dataDetail.canvas_setting.background,
          }"
        >
          <div class="width-canvas" style="padding: 0px 24px">
            <WheelOfFortune
              v-if="getGameSetting"
              :listItem="getGameSetting.listItem"
              :textSpinBtn="getGameSetting.textAction"
              :textSizeSpinBtn="getGameSetting.textSizeAction"
              :colorSpinBtn="getGameSetting.colorTextAction"
              :bgColorSpinBtn="getGameSetting.bgColorTextAction"
              :showSpinBtn="!getGameSetting.useBtnAction"
              :actionSpinWheel="actionSpinWheel"
              :colorFrame="getGameSetting.wheelOfFortune.colorFrame"
              :colorPointer="getGameSetting.wheelOfFortune.colorPointer"
              :colorMiddle="getGameSetting.wheelOfFortune.colorMiddle"
              :funcGetResultGame="getResultGame"
              @onEnd="handleEndWheel"
            />
          </div>
        </div>
        <div
          v-if="dataDetail.source == 'external'"
          style="width: 100%; height: 100%"
        >
          <GamemickDisplay
            v-if="dataDetail.partner_code == 'GAMEMICK'"
            :dataItem="dataDetail"
          />
        </div>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogInputPlay" width="500" persistent>
      <v-card rounded="lg">
        <v-card-text>
          <v-col cols="12" class="d-flex align-center justify-center">
            <v-icon color="#FFC107" size="96">mdi-alert-circle-outline</v-icon>
          </v-col>
          <v-col
            v-if="!checkConditionEntryPassFree(dataDetail)"
            cols="12"
            class="pa-0 d-flex flex-column align-center mb-0"
          >
            <div class="mb-2" style="font-size: 20px; color: #00000099">
              {{ $t("textConditionEntryPassGamification") }}
            </div>
            <div class="d-flex justify-center align-center">
              <div>
                <div v-if="dataDetail.input_type == 'point'">
                  <PointSymbol
                    v-if="
                      Array.isArray(dataDetail.point) &&
                      dataDetail.point.length > 0
                    "
                    :type="dataDetail.point[0].point_type_type"
                    :symbol="dataDetail.point[0].point_type_symbol"
                    :color="dataDetail.point[0].point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="28"
                  />
                </div>
                <v-icon v-else :color="site.color" size="28"
                  >mdi-ticket-confirmation-outline</v-icon
                >
              </div>
              <div
                class="pl-2"
                style="
                  font-size: 24px;
                  color: #00000099;
                  font-weight: bold;
                  word-break: break-word;
                  line-height: 1;
                "
              >
                {{ getConditionEntryPass(dataDetail) }}
              </div>
            </div>
          </v-col>
        </v-card-text>

        <v-card-actions class="pb-5 pt-0">
          <v-spacer></v-spacer>
          <v-btn
            :color="site.color"
            class="rounded-lg"
            outlined
            @click="handleClickCancelPlay"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            :color="site.color"
            class="rounded-lg white--text"
            depressed
            @click="handleClickConfirmPlay"
          >
            {{ $t("confirmDefault") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Axios from "@/config/customer-service";
import WheelOfFortune from "../../../components/game/wheel-of-fortune.vue";
import GamemickDisplay from "./partner/gamemick-display.vue";
import PointSymbol from "../../../components/point/point-symbol.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    WheelOfFortune,
    GamemickDisplay,
    PointSymbol,
  },
  data() {
    return {
      dataDetail: {
        id: null,
        name: "",
        description: "",
        image_url: "",
        type: "user",
        start_date: null,
        end_date: null,
        input_type: "point",
        reward_id: "",
        point: 0,
        canvas_setting: {},
        list_component: [],
        result_setting: {},
        source: "internal",
        partner_code: "",
        external_data: {},
      },
      actionSpinWheel: false,
      itemJson: null,
      resultItem: {},
      errorMsg: this.$t("errActivity"),
      checkInputError: false,
      listMyLuckyDraw: [],
      src: "",
      dialogInputPlay: false,
    };
  },

  async created() {
    this.isAppLoading(true);
    await this.getGamificationDetail(this.$route.params.id);
    await this.myLuckyDrawAll();
    if (!this.checkInputError) {
      this.handleCheckInputPlay();
    }
    this.isAppLoading(false);
  },
  methods: {
    redirectTo() {
      this.$router.push({
        name: "gamification-detail",
        params: {
          id: this.$route.params.id,
        },
      });
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },

    async getGamificationDetail(id) {
      try {
        const response = await Axios.get(
          "gamification/getGamificationDetail/" + id
        );
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse.data;
          this.dataDetail = data;
          const gameSetting = this.funcGetGameSetting();
          const listItem = gameSetting?.listItem || [];
          if (this.dataDetail.source == "internal") {
            let checkError = false;
            if (this.dataDetail.limit_reached_repeat) {
              checkError = true;
              this.errorMsg = `${this.$t("textSorry")} ${this.$t(
                "limitReached"
              )}`;
            } else if (this.dataDetail.limit_reached_repeat_per_day) {
              checkError = true;
              this.errorMsg = `${this.$t("textSorry")} ${this.$t(
                "limitReachedPerDay"
              )}`;
            } else if (listItem?.length == 0) {
              checkError = true;
              this.errorMsg = this.$t("errRewardOutOfStock");
            }
            if (checkError) {
              this.checkInputError = true;
              this.$swal
                .fire({
                  icon: "error",
                  title: this.errorMsg,
                  showConfirmButton: false,
                  timer: 3000,
                })
                .then(() => {
                  this.redirectTo();
                });
            }
          } else if (this.dataDetail.source == "external") {
            if (this.dataDetail.limit_reached) {
              this.checkInputError = true;
              this.errorMsg = this.$t("errRewardOutOfStock");
              this.$swal
                .fire({
                  icon: "error",
                  title: this.errorMsg,
                  showConfirmButton: false,
                  timer: 3000,
                })
                .then(() => {
                  this.redirectTo();
                });
            }
            if (this.dataDetail.partner_code == "GAMEMICK") {
              this.src =
                this.dataDetail.external_data?.game_detail?.game_url?.playable_url;
            }
          }
        } else {
          this.checkInputError = true;
          this.$swal
            .fire({
              icon: "error",
              title: response.data?.message,
              showConfirmButton: false,
              timer: 3000,
            })
            .then(() => {
              this.redirectTo();
            });
        }
      } catch (err) {
        this.checkInputError = true;
        this.$swal
          .fire({
            icon: "error",
            title: err?.response?.data?.message,
            showConfirmButton: false,
            timer: 3000,
          })
          .then(() => {
            this.redirectTo();
          });
      }
    },
    async myLuckyDrawAll() {
      try {
        const response = await Axios.get("reward/myLuckyDrawAll");
        const dataResponse = response.data;
        if (dataResponse?.status == "success") {
          this.listMyLuckyDraw = [...dataResponse.data];
        }
      } catch (err) {
        console.log("myLuckyDrawAll", err);
      }
    },

    async handleCheckInputPlay() {
      if (!this.checkConditionEntryPassFree(this.dataDetail)) {
        this.dialogInputPlay = true;
      }
    },
    async handleClickConfirmPlay() {
      const input_type = this.dataDetail.input_type;
      let point = 0;
      const list_point = this.dataDetail.point;
      if (input_type == "point") {
        if (
          Array.isArray(list_point) &&
          list_point.length > 0 &&
          list_point[0].point
        ) {
          point = list_point[0].point;
        }
      }
      const reward_id = this.dataDetail.reward_id;
      // ========== ========== ========== ==========
      let checkCanPlay = true;
      if (input_type == "point") {
        const cur_point = this.customer?.point || 0;
        if (cur_point < point) {
          checkCanPlay = false;
          this.$swal
            .fire({
              icon: "warning",
              text: `${this.$t("textSorry")} ${this.$t("coin")}${this.$t(
                "notEnough"
              )}`,
              showCancelButton: false,
              confirmButtonText: this.$t("back"),
              confirmButtonColor: "#000000",
              allowOutsideClick: false,
            })
            .then((result2) => {
              if (result2.isConfirmed) {
                this.redirectTo();
              }
            });
        }
      } else if (input_type == "reward") {
        const count = this.listMyLuckyDraw.filter(
          (x) => x.status == 1 && x.reward_id == reward_id
        ).length;
        if (count == 0) {
          checkCanPlay = false;
          this.$swal
            .fire({
              icon: "warning",
              text: this.$t("errMyLuckyDrawNotEnough"),
              showCancelButton: false,
              confirmButtonText: this.$t("back"),
              confirmButtonColor: "#000000",
              allowOutsideClick: false,
            })
            .then((result2) => {
              if (result2.isConfirmed) {
                this.redirectTo();
              }
            });
        }
      }
      if (checkCanPlay) {
        this.dialogInputPlay = false;
      }
    },
    async handleClickCancelPlay() {
      this.dialogInputPlay = false;
      this.redirectTo();
    },
    async handleEndWheel() {
      if (this.itemJson) {
        const text =
          !this.itemJson.hideText && this.itemJson.name
            ? `<div style="font-weight: 400; margin-bottom: 8px;">${this.$t(
                "textCongratsReceived"
              )}<br/><div style="font-weight: 600;">${
                this.itemJson.name
              }</div></div>`
            : ``;
        const image = this.itemJson.image
          ? `<img style="width: 100%; object-fit: contain;" src="${this.itemJson.image}" />`
          : ``;
        let html = `
          ${text}
          ${image}
        `;
        this.$swal
          .fire({
            icon: "success",
            html: html,
            showCancelButton: false,
            confirmButtonText: this.$t("viewHistory"),
            confirmButtonColor: "#2196F3",
            allowOutsideClick: false,
          })
          .then((result2) => {
            if (result2.isConfirmed) {
              this.$router.push({
                name: "gamification-history",
                params: { id: this.$route.params.id },
              });
            }
          });
      } else {
        const textError = this.errorMsg;
        const textBtn = this.$t("back");
        this.$swal
          .fire({
            icon: "warning",
            text: textError,
            showCancelButton: false,
            confirmButtonText: textBtn,
            confirmButtonColor: "#000000",
            allowOutsideClick: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.redirectTo();
            }
          });
      }
    },
    async getResultGame() {
      let item_id = null;
      try {
        const response = await Axios.post(
          `gamification/getAndUpdateTransactionResultGame/${this.$route.params.id}`
        );
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse.data;
          item_id = data?.result?.item_id;
          this.itemJson = data?.result?.item_json;
        } else {
          this.errorMsg = dataResponse?.message;
        }
      } catch (err) {
        console.log(err);
      }
      return item_id;
    },
    handleStartGame() {
      const gameSetting = this.funcGetGameSetting();
      if (!gameSetting || gameSetting.listItem?.length == 0) {
        this.redirectTo();
        return;
      }
      // ========== ========== ========== ==========
      this.actionSpinWheel = true;
      setTimeout(() => {
        this.actionSpinWheel = false;
      }, 500);
    },
    funcGetGameSetting() {
      let data = null;
      if (
        Array.isArray(this.dataDetail?.list_component) &&
        this.dataDetail?.list_component.length > 0
      ) {
        const model = this.dataDetail?.list_component.find(
          (x) => x.type == "game"
        );
        if (model) {
          data = { ...model.gameSetting };
        }
      }
      return data;
    },

    getConditionEntryPass(param) {
      let text = `-`;
      const input_type = param.input_type;
      const point = param.point;
      const reward_name = param.reward_name;
      if (input_type == "point") {
        if (Array.isArray(point) && point.length > 0 && point[0].point) {
          text = `${this.commaPoint(point[0].point)} ${
            point[0].point_type_name
          }`;
        }
      } else if (input_type == "reward" && reward_name) {
        text = `${reward_name}`;
      }
      return text;
    },
    checkConditionEntryPassFree(param) {
      let isFree = false;
      const input_type = param.input_type;
      const point = param.point;
      if (input_type == "point") {
        if (
          !point ||
          (Array.isArray(point) && point.length > 0 && !point[0].point)
        ) {
          isFree = true;
        }
      }
      return isFree;
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
    getGameSetting() {
      let data = null;
      if (
        Array.isArray(this.dataDetail?.list_component) &&
        this.dataDetail?.list_component.length > 0
      ) {
        const model = this.dataDetail?.list_component.find(
          (x) => x.type == "game"
        );
        if (model) {
          data = { ...model.gameSetting };
        }
      }
      return data;
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped>
.text-dot {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.width-canvas {
  width: 100%;
}

@media only screen and (min-width: 480px) {
  .width-canvas {
    width: 80%;
  }
}

@media only screen and (min-width: 600px) {
  .width-canvas {
    width: 75%;
  }
}

@media only screen and (min-width: 960px) {
  .width-canvas {
    width: 70%;
  }
}

@media only screen and (min-width: 1260px) {
  .width-canvas {
    width: 50%;
  }
}
</style>